module.exports = __webpack_public_path__ + "img/forensics_australia_splash.d997a73c.jpg";